import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "./index.css";

function ProductSlider({ images, videos }) {
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    let sliderRef1 = useRef(null);
    let sliderRef2 = useRef(null);

    useEffect(() => {
        setNav1(sliderRef1);
        setNav2(sliderRef2);
    }, []);
    const settings = {
        vertical: false,
        infinite: true,
        loop: true,
    };
    return (
        <div className="slider-container">
            <div className="bg-product-slider">
                <Slider dots={false} arrows={false} asNavFor={nav2} ref={slider => (sliderRef1 = slider)}>
                    {images && (
                        images?.map((item, index) => (
                            <div key={index}>
                                <div className="product-details-img position-relative">
                                    <img src={item.path} alt="" className="img-fluid" />
                                </div>
                            </div>
                        ))
                    )}
                    {videos && (
                        videos?.map((item, index) => (
                            <div key={index}>
                                <div className="product-details-img position-relative">
                                    <video src={item.path} alt="" className="img-fluid" />
                                </div>
                            </div>
                        ))
                    )}
                </Slider>
            </div>
            <div className="sm-product-slider">
                <Slider
                    vertical={true}
                    {...settings}
                    asNavFor={nav1}
                    ref={slider => (sliderRef2 = slider)}
                    slidesToShow={3}
                    swipeToSlide={true}
                    focusOnSelect={true}
                    arrows={false}
                >
                    {images && (
                        images?.map((item, index) => (
                            <div key={index} className="w-100 mt-3 px-2">
                                <div className="product-details-img-sm">
                                    <img src={item.path} alt="" className="img-fluid" />
                                </div>
                            </div>
                        ))
                    )}
                    {videos && (
                        videos?.map((item, index) => (
                            <div key={index} className="w-100 mt-3 px-2">
                                <div className="product-details-img-sm">
                                    <video src={item.path} alt="" className="img-fluid" />
                                </div>
                            </div>
                        ))
                    )}
                </Slider>
            </div>
        </div>
    );
}

export default ProductSlider;
